import styled from 'styled-components';

export const DescriptionText = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const SubjectToValidateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .ant-form-item {
    margin-bottom: 0;
  }
`;
